export class ObjectUtil {
    public static shallowEqual(a: any, b: any): boolean {
        if (a === b) {
            return true;
        }
        const aKeys = Object.keys(a as object);
        const bKeys = Object.keys(b as object);
        if (aKeys.length !== bKeys.length) {
            return false;
        }
        for (const k of aKeys) {
            if ((a as any)[k] !== (b as any)[k]) {
                return false;
            }
        }
        return true;
    }

    public static getNestedPropertyValue(obj: any, path: string): any {
        return path.split(".").reduce((current, key) => {
            return current && current[key] !== undefined ? current[key] : undefined;
        }, obj);
    }
}
